export enum DateRangeValueTypeEnum {
  FROM = "from",
  TO = "to",
}
